import React from "react";

function Footer() {
  return (
    <footer style={{ backgroundColor: "#333", color: "#fff", padding: "20px", textAlign: "center" }}>
      <img
        src="/images/footer-image.png"
        alt="Footer Logo"
        style={{ width: "100%", height: "auto" }}
      />
      <p style={{ marginTop: "10px" }}>© 2025 Real Estate Investment Calculator. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
